import {createContext, useContext, useEffect, useReducer} from "react";
import {initialState, reducer, setAddressList, setAddressQuery, setFormVisible, setLoading} from "./reducer";
import {useDelAddressInfo, useGetAddressByPassId, useSetDefaultAddress} from "../../../../api/UdianSysUserAddressInfo";
import useNotice from "../../../../hooks/useNotice";
import Dialog from "../../../../publicComponent/Dialog";

const Context = createContext(initialState);

function ShippingAddressController() {
  const { state, dispatch } = useShippingAddressContext();
  const { loading, getList } = useGetAddressByPassId();
  const { setDefault } = useSetDefaultAddress();
  const { remove } = useDelAddressInfo();
  const notice = useNotice();
  
  
  const formVisibleHandle = (item = {}) => {
    dispatch(setAddressQuery(item));
    dispatch(setFormVisible(true));
  };
  
  const closeFormVisible = () => {
    dispatch(setFormVisible(false));
  };
  
  const getAddressList = async () => {
    let { data } = await getList();
    if (data) {
      dispatch(setAddressList(data));
    }
  };
  
  const removeAddress = async (id) => {
    Dialog.confirm({
      content: '是否删除该地址?',
      onOk: async (onClose) => {
        let { data } = await remove({ id });
        if (data) {
          notice.success('删除成功');
          getAddressList();
        }
        onClose();
      }
    });
    
  };
  
  const setDefaultAddress = async (id) => {
    let { data } = await setDefault({ id });
    if (data) {
      getAddressList();
    }
  };
  
  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);
  
  return {
    formVisibleHandle,
    closeFormVisible,
    getAddressList,
    removeAddress,
    setDefaultAddress,
  };
  
}

function useShippingAddressContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useShippingAddressContext, ShippingAddressController};

export default function ShippingAddressContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
